export default "__VITE_ASSET__f230c2a9__"